import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import baseCss from "./styles";
import { AuthProvider } from "./auth";
import { CartProvider } from "./cart";
import { PAYPAL_CLIENT_ID } from "./shared";
import { initGA4, trackPageView } from "./analytics";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";
import HomeGrid from "./pages/HomeGrid";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrderConfirmation from "./pages/OrderConfirmation";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ShippingPage from "./pages/ShippingPage";
import PrivacyPage from "./pages/PrivacyPage";
import AccessibilityPage from "./pages/AccessibilityPage";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import NotFound from "./pages/NotFound";

function AnalyticsListener() {
  const loc = useLocation();
  const GA4_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || "";

  useEffect(() => {
    initGA4(GA4_ID);
  }, [GA4_ID]);

  useEffect(() => {
    const path = `${loc.pathname}${loc.search || ""}`;
    trackPageView({ measurementId: GA4_ID, path });
  }, [GA4_ID, loc.pathname, loc.search]);

  return null;
}

/**********************
 * Root Export — wrap existing app with Auth + PayPal provider
 *********************/
export default function JewelryHome() {
  return (
    <div className="jh-root">
      <style>{baseCss}</style>
      <AuthProvider>
        <PayPalScriptProvider
          options={{ "client-id": PAYPAL_CLIENT_ID, currency: "USD" }}
        >
          <CartProvider>
            <BrowserRouter>
              <AnalyticsListener />
              <SiteHeader />
              <Routes>
                <Route path="/" element={<HomeGrid />} />
                <Route path="/product/:sku" element={<ProductDetailPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order/:id" element={<OrderConfirmation />} />
                <Route path="/shipping" element={<ShippingPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/accessibility" element={<AccessibilityPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              <SiteFooter />
            </BrowserRouter>
          </CartProvider>
        </PayPalScriptProvider>
      </AuthProvider>
    </div>
  );
}
